import React from 'react'

import CatalogueFilterCheckbox from './catalogue-filter-checkbox'

const CatalogueFilterCheckboxList = ({list, filter, filterName, updateFilters}) => {
  const handleClick = event => {
    const value = event.target.name;
    const newFilter = [...filter];

    const index = filter.indexOf(value);

    if (index > -1) {
      newFilter.splice(index, 1);
    } else if (value) {
      newFilter.push(value)
    }

    updateFilters(newFilter)
  };

  const itemList = list
    .map(name => <CatalogueFilterCheckbox name={name} filter={filter} key={name}/>);

  const itemList1 = itemList && itemList.filter((_, i) => i % 2 === 0);
  const itemList2 = itemList && itemList.filter((_, i) => i % 2 !== 0);

  return (
    <ul onClick={handleClick}>
      <div className="list-1">
        {itemList1}
      </div>
      <div className="list-2">
        {itemList2}
      </div>
    </ul>
  )
};

CatalogueFilterCheckboxList.defaultProps = {
  list: []
};

export default CatalogueFilterCheckboxList
